export default "__VITE_ASSET__BV_63fRN__"